import GenericErrorComponent from '@/features/errors/components/generic-error-component';
import { Button } from '@thisisdmg/tirecloud-patterns/v2';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function Error404() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="tw:h-1 tw:[min-height:inherit]">
      <GenericErrorComponent
        errorCode={[4, 0, 3]}
        errorMessage={t('page.errors.error403.title')}
        errorDetails={t('page.errors.error403.description')}
        actionButton={
          <div className="tc:inline-flex tc:gap-x-2">
            <Button.Solid
              color="brand"
              onClick={() => {
                navigate(
                  {
                    pathname: '/products',
                    search: new URLSearchParams({ ref: 'not_found' }).toString(),
                  },
                  {
                    replace: true,
                  }
                );
              }}
            >
              {t('page.errors.error403.goBackHome')}
            </Button.Solid>
          </div>
        }
      />
    </div>
  );
}
